import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Icons } from 'utoniq-ui'

import {
  ArtistPreSaleLotteryApplicantDetailFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type UserInfoCellProps = {
  user: Maybe<ArtistPreSaleLotteryApplicantDetailFragment['user']>
}

export const UserInfoCell: Cell<UserInfoCellProps> = ({ user }) => {
  const { t } = useTranslation('consoleLotteryManagementDetail')
  return (
    <CellFrame sx={{ pb: 9 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={3}
        mt={3}
      >
        <Typography variant="h5" color="text.secondary">
          {t('userInfoHead', '顧客情報')}
        </Typography>
      </Stack>
      <Stack spacing={2} sx={{ bgcolor: 'grey.50', p: 5, borderRadius: 2 }}>
        <Stack spacing={1}>
          <Typography variant="subtitle1" color="text.secondary">
            {t('familyName', '氏名')}
          </Typography>
          <Typography variant="body2">{user?.fullName}</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="subtitle1" color="text.secondary">
            {t('shippingAddress', '住所')}
          </Typography>
          <Typography variant="body2">{user?.address?.fullAddress}</Typography>
        </Stack>
        <Stack spacing={1}>
          <Stack direction="row" spacing={3} alignItems="center">
            <Typography variant="subtitle1" color="text.secondary">
              {t('phoneNumber', '電話番号')}
            </Typography>
            {user?.isPhoneNumberVerified && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Icons.Success
                  fontSize="small"
                  sx={{ color: 'text.hint', mt: -1 }}
                />
                <Typography variant="body2" color="text.hint">
                  {t('verified')}
                </Typography>
              </Stack>
            )}
          </Stack>
          <Typography variant="body2">{user?.formattedPhoneNumber}</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="subtitle1" color="text.secondary">
            {t('email', 'メールアドレス')}
          </Typography>
          <Typography variant="body2">{user?.email}</Typography>
        </Stack>
      </Stack>
    </CellFrame>
  )
}
